import MenuSection from "./MenuSection";
import { useSearch } from "../SearchContext";
import SubCategoryItems from "./SubCategoryItems";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import BackButton from "./BackButton";

import React, { Suspense, lazy, useEffect, useRef, useState } from "react";

function SearchSection(props) {
  const {
    searchData,
    handleSearchChange,
    setSearchData,
    filter,
    handleFilterChange,
    isAllSelected,
    searchAllCategories,
    setSearchAllCategories,
  } = useSearch();
  const cart = props.cart;
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation();
  const showBackButton = props.showBackButton;
  const inputRef = useRef(null);

  // Collapsed to an icon until the customer taps it (or there's already a
  // search term, e.g. from navigating back) — keeps the sticky bar slim.
  const [isSearchOpen, setIsSearchOpen] = useState(Boolean(searchData));

  useEffect(() => {
    if (searchData) setIsSearchOpen(true);
  }, [searchData]);

  const openSearch = () => {
    setIsSearchOpen(true);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const closeSearch = () => {
    if (searchData) return; // keep it open while there's a query to show/clear
    setIsSearchOpen(false);
  };

  //const [searchAllCategories, setSearchAllCategories] = useState(false);

  return (
    <div
      className="sticky top-14 sm:top-16 z-40 px-3 py-2 md:px-4 md:py-2.5 bg-white shadow-sm"
      id="searchboxSection"
    >
      {/* Search Input with Back Button */}
      <div className="flex items-center gap-2">
        {showBackButton && (
          <BackButton onClick={() => navigate(`/${location.search}`)} />
        )}

        {isSearchOpen ? (
          <div className="relative group flex-1">
            <div className="absolute inset-y-0 left-0 pl-2.5 md:pl-3.5 flex items-center pointer-events-none">
              <svg
                className="h-4 w-4 md:h-5 md:w-5 text-orange-400 group-focus-within:text-orange-500 transition-colors duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <input
              ref={inputRef}
              id="searchbox"
              type="search"
              className="w-full pl-9 pr-3 py-1.5 md:pl-11 md:pr-4 md:py-2 text-xs md:text-sm bg-white border-2 border-orange-200/40 rounded-xl md:rounded-2xl focus:bg-white focus:ring-4 focus:ring-orange-400/20 focus:border-orange-400 outline-none transition-all placeholder-gray-400 shadow-md hover:shadow-lg hover:border-orange-300 font-medium"
              onChange={handleSearchChange}
              onBlur={closeSearch}
              placeholder={t("searchPlaceholder")}
              value={searchData}
              autoFocus
            />
          </div>
        ) : (
          <>
            {props.title && (
              <span className="flex-1 text-sm font-semibold text-gray-800 truncate">
                {props.title}
              </span>
            )}
            <button
              type="button"
              onClick={openSearch}
              className={`flex-shrink-0 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-orange-600 hover:bg-orange-50 rounded-full transition-colors ${
                props.title ? "" : "ms-auto"
              }`}
              aria-label={t("searchPlaceholder") || "Search"}
            >
              <svg
                className="h-4.5 w-4.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </>
        )}
      </div>

      {/* All Category Toggle */}
      {searchData && (
        <div className="flex items-center justify-between mt-2 md:mt-3.5 px-1 py-1.5 md:py-2 bg-white/60 rounded-xl">
          <span className="text-[10px] md:text-xs font-semibold text-gray-700">
            {t("searchAllCategories")}
          </span>
          <button
            onClick={() => setSearchAllCategories((prev) => !prev)}
            className={`relative inline-flex h-6 w-11 md:h-7 md:w-13 rounded-full transition-all duration-300 focus:outline-none shadow-sm ${
              searchAllCategories
                ? "bg-gradient-to-r from-orange-500 to-orange-600"
                : "bg-gray-300"
            }`}
          >
            <span
              className={`absolute top-1/2 h-5 w-5 md:h-6 md:w-6 -translate-y-1/2 rounded-full bg-white shadow-lg transition-all duration-300
      ${
        searchAllCategories
          ? isRTL
            ? "right-1"
            : "left-1 translate-x-5"
          : isRTL
            ? "left-1"
            : "left-1"
      }
    `}
            />
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchSection;
